export const isAllColumnsSelected = (data: MappedColumn[]) => data.filter(filterRowOptions).every((el) => el.isVisible);

export const getLabelFromColumn = (column: MappedColumn) => {
    // Extracts a user-friendly label from a column definition
    // If the Header is a function (React component), it uses meta.columnLabel or falls back to column.id
    const header = column.Header;
    return typeof header === 'function' ? (column.meta?.columnLabel ?? column.id) : (header ?? '');
};

export const unifyColumnDefinition = (item: Column & { isVisible: boolean }): MappedColumn => {
    // Normalizes different table column definitions (react-table v8 & main-table) into a single unified column format
    const Header = 'Header' in item ? item.Header : item.header;
    const accessor = 'Header' in item ? item.accessor : item.accessorKey;

    return {
        id: item.id,
        Header,
        accessor,
        isVisible: item.isVisible,
        isDisableReorder: item.isDisableReorder ?? false,
        isDisableVisibility: item.isDisableVisibility ?? false,
        ...(item.meta?.columnLabel && {
            meta: { columnLabel: item.meta.columnLabel },
        }),
    };
};

interface ColumnV8 {
    id: string;
    accessorKey: string;
    header: string;
    isDisableReorder: boolean;
    isDisableVisibility: boolean;
    meta?: {
        columnLabel?: string;
    };
}

interface ColumnMainTable {
    id: string;
    accessor: string;
    Header: string;
    isDisableReorder: boolean;
    isDisableVisibility: boolean;
    meta?: {
        columnLabel?: string;
    };
}

export type Column = ColumnV8 | ColumnMainTable;

export interface MappedColumn {
    id: string;
    Header: string | Function;
    isVisible: boolean;
    isDisableReorder: boolean;
    isDisableVisibility: boolean;
    accessor: string;
    meta?: {
        columnLabel?: string;
    };
}

export const filterRowOptions = (item: { id: string }) => !['select-col', 'rowOptions'].includes(item.id);
export const filterColumnsVisibility = ({
    columns,
    visibilityCondition,
}: {
    columns: Column[];
    visibilityCondition: (value: Column) => boolean;
}): MappedColumn[] => {
    return columns
        .filter(filterRowOptions)
        .map((item) => ({
            ...item,
            isVisible: visibilityCondition(item),
        }))
        .map(unifyColumnDefinition);
};
